/**
 * 1.4.2 네트워크 설정 Store
 *
 * @since 2017-12-12
 * @author devp020
 */
import {SystemApiPrefix as apiPrefix} from '~/utils/restApi'
import {ifcDataTreeConvert} from '~/utils/device-common'

export const state = () => ({
  errorMessage: null,
  // api url 목록
  apiUrl: {
    bondUrl: `${apiPrefix}/bond`,
    interfacesUrl: `${apiPrefix}/interfaces`,
    memberUrl: `${apiPrefix}/bond/interface_member`,
    routingsUrl: `${apiPrefix}/static-routings`
  },
  // bond
  bondInfo: {
    name: '',
    members: [],
    mode: 'active-backup',
    primary: '',
    link_monitoring: 'MII',
    monitoring_interval: '1000',
    arp_ip_target: '',
    updelay: '1000',
    downdelay: '1000'
    // usage: '1'
  },
  memberList: [],
  interfacesList: [],
  orgInterfacesInfo: {},
  interfacesInfo: {
    ipaddr: '172.17.0.3/16',
    main_ifc: 'no',
    link: 'no',
    network_type: 'static',
    ipv6addr: [
      'fe80::42:acff:fe11:3/64'
    ],
    type: '0',
    updown: 'UP',
    mtu: '1500',
    name: 'eth0',
    usage: '',
    alias: []
  },
  interfacesOptions: [],
  // interfacesResult: null,
  routingsList: [],
  routingsInfo: {
    default_yn: 1, // 0: 특정, 1: 디폴트
    address: '',
    gateway: '',
    interface: '',
    metric: '',
    version: 4 // IPv4: 4, IPv6: 6
  }
  // routingsResult: null
})

export const mutations = {
  // 인터페이스 목록 조회
  mutInterfacesList (state, payload) {
    state.interfacesList = ifcDataTreeConvert(payload)
    state.interfacesOptions = _.map(_.remove(_.cloneDeep(payload), (items) => {
      return items.type !== '2'
    }), (items) => {
      return {value: items.name, label: items.name}
    })
  },
  // 인터페이스 조회
  mutInterfacesInfo (state, payload) {
    state.orgInterfacesInfo = _.cloneDeep(payload)
    state.interfacesInfo = {
      ipaddr: _.isNil(payload.ipaddr) ? '' : payload.ipaddr,
      main_ifc: _.isNil(payload.main_ifc) ? 'no' : _.toLower(payload.main_ifc),
      link: payload.link,
      network_type: _.isNil(payload.network_type) || payload.type !== '0' || payload.link === 'no' ? 'static' : payload.network_type,
      ipv6addr: _.isNil(payload.ipv6addr) ? [] : payload.ipv6addr,
      type: payload.type,
      updown: _.toUpper(payload.updown),
      mtu: payload.mtu,
      name: payload.name,
      usage: payload.usage,
      alias: payload.alias
    }
  },
  // 인터페이스 설정 수정
  // mutPutInterfaces (state, payload) {
  //   state.interfacesResult = payload
  // },
  // 본드 멤버 목록 조회
  setMemberList (state, payload) {
    state.memberList = _.map(_.remove(payload, (items) => {
      return (_.toLower(items.slave) === 'no' || (!_.isUndefined(items.master) && _.toLower(items.master) === state.bondInfo.name))
    }), (items) => {
      return {value: items.name, label: items.name}
    })
  },
  setBondInfoParams (state, {key = void 0, val = void 0} = {}) {
    if (!key) return
    _.set(state.bondInfo, key, val)
    state.bondInfo = _.cloneDeep(state.bondInfo)
  },
  clearBondInfo (state) {
    state.bondInfo = {
      name: '',
      members: [],
      mode: 'active-backup',
      primary: '',
      link_monitoring: 'MII',
      monitoring_interval: '1000',
      arp_ip_target: '',
      updelay: '1000',
      downdelay: '1000'
      // usage: '1'
    }
  },
  setInterfacesBond (state, payload) {
    state.bondInfo = payload
  },
  // 라우팅 목록 조회
  mutRoutingsList (state, payload) {
    state.routingsList = payload
  },
  mutRoutingsReset (state) {
    state.routingsList = {}
  },
  // 라우팅 경로 초기화
  clearRoutingsInfo (state, yn = 1) {
    state.routingsInfo.default_yn = yn
    state.routingsInfo.address = ''
    state.routingsInfo.gateway = ''
    state.routingsInfo.interface = ''
    state.routingsInfo.metric = ''
    state.routingsInfo.version = 4
  },
  // 라우팅 정보 입력
  // mutPostRoutings (state, payload) {
  //   state.routingsResult = payload
  // },
  // 라우팅 정보 삭제
  // mutDelRoutings (state, payload) {
  //   state.routingsResult = payload
  // },
  mutationErrorMessage (state, data) {
    const msg = _.isNil(data.msg) ? '' : {
      error: data.msg
    }
    state.errorMessage = msg
  }
}

export const actions = {
  // 인터페이스 목록 조회
  async acsInterfacesList ({commit, state}) {
    commit('mutInterfacesList', [])
    const {code, result} = await this.$axios.$get(`${state.apiUrl.interfacesUrl}`)
    if (code === 'ok') {
      commit('mutInterfacesList', result)
      return true
    }
    commit('mutationErrorMessage', result)
    return false
  },
  // 인터페이스 조회
  async acsInterfacesInfo ({commit, state}, payload) {
    const {code, result} = await this.$axios.$get(`${state.apiUrl.interfacesUrl}/${payload.name}`, {loading: false, loadingShow: false})
    if (code === 'ok') {
      commit('mutInterfacesInfo', result)
      return true
    }
    commit('mutInterfacesInfo', [])
    commit('mutationErrorMessage', result)
    return false
  },
  // 인터페이스 설정 수정
  async acsPutInterfaces ({commit, state}, payload) {
    let edtParam = _.cloneDeep(payload)
    if (_.toUpper(payload.updown) === 'DOWN') {
      edtParam = _.cloneDeep(state.orgInterfacesInfo)
      edtParam.updown = 'DOWN'
    }
    const {code, result} = await this.$axios.$put(`${state.apiUrl.interfacesUrl}/${payload.name}`, edtParam)
    if (code === 'ok') {
      // commit('mutPutInterfaces', result)
      return true
    }
    commit('mutationErrorMessage', result)
    return false
  },
  // 본드 멤버 목록 조회
  async getInterfacesMember ({commit, state}) {
    const {code, result} = await this.$axios.$get(state.apiUrl.memberUrl)
    if (code === 'ok') {
      commit('setMemberList', result)
      return true
    }
    // commit('setMemberList', state.memberListTmp)
    commit('mutationErrorMessage', result)
    return false
  },
  // 본드 조회
  async getInterfacesBond ({commit, state}) {
    const {code, result} = await this.$axios.$get(`${state.apiUrl.bondUrl}/${state.interfacesInfo.name}`)
    if (code === 'ok') {
      commit('setInterfacesBond', result)
      return true
    }
    commit('mutationErrorMessage', result)
    return false
  },
  // 본드 추가
  async addInterfacesBond ({commit, state}) {
    const {code, result} = await this.$axios.$post(state.apiUrl.bondUrl, state.bondInfo)
    if (code === 'ok') {
      return true
    }
    commit('mutationErrorMessage', result)
    return false
  },
  // 본드 편집
  async edtInterfacesBond ({commit, state}) {
    const {code, result} = await this.$axios.$put(`${state.apiUrl.bondUrl}/${state.bondInfo.name}`, state.bondInfo)
    if (code === 'ok') {
      return true
    }
    commit('mutationErrorMessage', result)
    return false
  },
  // 본드 삭제
  async delInterfacesBond ({commit, state}, payload) {
    const {code, result} = await this.$axios.$delete(`${state.apiUrl.bondUrl}/${payload.name}`, {data: payload})
    if (code === 'ok') {
      return true
    }
    commit('mutationErrorMessage', result)
    return false
  },
  // 라우팅 목록 조회
  async acsRoutingsList ({commit, state}) {
    const {code, result} = await this.$axios.$get(state.apiUrl.routingsUrl)
    if (code === 'ok') {
      commit('mutRoutingsList', result)
      return true
    }
    commit('mutRoutingsList', [])
    commit('mutationErrorMessage', result)
    return false
  },
  // 라우팅 정보 입력
  async acsPostRoutings ({commit, state}, payload) {
    const {code, result} = await this.$axios.$post(state.apiUrl.routingsUrl, payload)
    if (code === 'ok') {
      // commit('mutPostRoutings', result)
      return true
    }
    commit('mutationErrorMessage', result)
    return false
  },
  // 라우팅 정보 삭제
  async acsDelRoutings ({commit, state}, payload) {
    const {code, result} = await this.$axios.$delete(state.apiUrl.routingsUrl, {data: payload})
    if (code === 'ok') {
      return true
    }
    commit('mutationErrorMessage', result)
    return false
  }
}
export const getters = {}
export const strict = false
